import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b7aebd6b5d6f0014e75a43/netsiem/src/app/alert-configuration/components/AlertRulesTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69b7aebd6b5d6f0014e75a43/netsiem/src/components/AppLayout.tsx");
